
import CustomClientClass4 from './custom_client4.jsx';


const CustomClient4 = new CustomClientClass4();

export {
    CustomClient4
};


// WEBPACK FOOTER //
// ./custom-redux/client/index.jsx